import {
    SELECT_WORKSPACE, REQUEST_WORKSPACES, RECEIVE_WORKSPACES, CLEAN_WORKSPACES
  } from './workspaces.actions';

  export const workspacesInitialState: IWorkspacesState = {
    selectedWorkspaceId: null,
    entities: {
      workspaces: []
    },
    result: undefined,
    isFetching: false,
  };

  export function workspacesReducer(state = workspacesInitialState, action) {
    switch (action.type) {
      case REQUEST_WORKSPACES:
        return Object.assign({}, state, {
          isFetching: true
        });
      case RECEIVE_WORKSPACES:
        const result = action.result;
        return Object.assign({}, state, result, {
          isFetching: false,
        });
      case SELECT_WORKSPACE:
        let selectedWorkspaceId = action.result;
        const orgId = action.orgId;
        if (orgId && selectedWorkspaceId == null) {
          const workspaces = state.entities.workspaces;
          const orgWorkspaces = Object.values(workspaces).filter((workspace) => workspace.orgId == orgId);
          const defaultWorkspace = orgWorkspaces.find((workspace) => workspace.isDefault);
          if(defaultWorkspace) {
            selectedWorkspaceId = defaultWorkspace.globalId;
          } else {
            selectedWorkspaceId = orgWorkspaces[0].globalId;
          }
        }
        return Object.assign({}, state, {}, {
          selectedWorkspaceId,
        });
      case CLEAN_WORKSPACES:
        return Object.assign({}, workspacesInitialState, {
          isFetching: false
        });
      default:
          return state;
    }
  }

  export interface IWorkspacesState {
    selectedWorkspaceId: string,
    isFetching: boolean;
    entities: {
      workspaces: IWorkspaceInstance[]
    };
    result,
  }

  export interface IWorkspaceInstance {
    id: number;
    globalId: string;
    orgId: string;
    userId: number;
    createdAt: number;
    updatedAt: number;
    title: string;
    isDefault: boolean;
    privileges: [{}];
    owner: {};
    countMembers: number;
    color: string;
  }
